import { Component, AfterViewInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DataShareService } from '../../../services/data-share.service';
import { SignalService } from '../../../services/signal.service';
import { AuthService } from '../auth.service';
import { AccountMembership } from 'app/API.service.custom';
import localforage from 'localforage';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sign-out',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignOutComponent implements AfterViewInit, OnDestroy {
  allUsersSubscription?: Subscription;
  activAccountSubscription?: Subscription;
  allUsers;
  activeAccount : AccountMembership = null;
  isDoneOnce = false;

  constructor(private auth: AuthService, private router: Router, private os: SignalService, private dataService: DataShareService) { }

  ngAfterViewInit() {
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
      }
      this.allUsersSubscription?.unsubscribe();
      this.allUsersSubscription = this.dataService.getAllUsersInAccount().subscribe((param_all: any) => {
        if (param_all) {
          this.allUsers = param_all;
          if(this.allUsers.length > 1 && !this.isDoneOnce){
              let regNumber = this.activeAccount.user.registeredNumber;
              localforage.setItem('lastSuccessfulSigninNumber', regNumber);
          }
        }
        if(!this.isDoneOnce){
          this.isDoneOnce = true;
          this.clearAtSignOut();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.activAccountSubscription?.unsubscribe();
    this.allUsersSubscription?.unsubscribe();
  }

  async clearAtSignOut(){
    await this.removeOneSignalExternalUserId();
    await this.resetAllSavedDataInService();
    await this.auth.signOut();
    this.router.navigate(['/sign-in']);
  }


  removeOneSignalExternalUserId(): Promise<void> {
    return this.os.removeExternalId(2000);
  }

  resetAllSavedDataInService(){
    this.dataService.setActiveAccount(null);
    this.dataService.setAllUserAccountMemberships(null);
    this.dataService.setTeams(null);
    this.dataService.setAllTeamMemberships(null);
    this.dataService.setAllUsersInAccount(null);
    this.dataService.setUserAuthorization(null);
    this.dataService.setAllDirectTeams(null);
    this.dataService.setDirectTeamsAsTL(null);
    this.dataService.setDirectTeamsAsReportee(null);
    this.dataService.setIndirectTeamsAsLead(null);
    this.dataService.setDirectReportees(null);
    this.dataService.setInDirectReportees(null);
    this.dataService.setOnUpdateAllEngagementAccountLevelListener(null);
    this.dataService.setOnCreateAllEngagementAccountLevelListener(null);
    this.dataService.setOnCreateAllEngagementUserLevelListener(null);
    this.dataService.setOnUpdateAllEngagementUserLevelListener(null);
    this.dataService.setOnCreateActivityAccountLevelListener(null);
    this.dataService.setOnCreateActivityUserLevelListener(null);
    this.dataService.setOnCreateMentionUserMembershipUserLevelListener(null);
    this.dataService.setOnUpdateRealTimeMetricsListener(null);
    this.dataService.setOnUpdateAccountMemberActivityListener(null);
    this.dataService.setCallOutcomeTypes(null);
    this.dataService.setVisitOutcomeTypes(null);
    this.dataService.setTaskTypes(null);
    this.dataService.setDealStages(null);
    this.dataService.setTicketStages(null);
    this.dataService.setTicketCategories(null);
    this.dataService.setCallingScripts(null);
    this.dataService.setLastActivitySeenAt(null);
    this.dataService.setLastContactSeenAt(null);
    this.dataService.setLastEngagementSeenAt(null);
    this.dataService.setLastCallSeenAt(null);
    this.dataService.setLastMessageSeenAt(null);
    this.dataService.setLastVisitSeenAt(null);
    this.dataService.setLastTaskSeenAt(null);
    this.dataService.setLastDealSeenAt(null);
  }


}
